export class CyclicModeDataQueryOPathes {
  constructor(private parent: DataQueryOPathes) {}

  private get mtObjWorkTypeEarliestExecutionDateOPath() {
    return `
CaseWhen
(
  CycleUnit
,
  0
,
  AddDays
  (
    GetDate(ExecFirst)
  ,
    Ceiling
    (
      ToFloat
      (
        Ceiling(ToFloat(GetDate($${this.parent.paramName_TodayDate}) - GetDate(ExecFirst)) / 7.0)
        /
        ToFloat(CycleLength)
      )
    ) * (CycleLength * 7)
  )
,
  1
,
  AddMonths
  (
    GetDate(ExecFirst)
  ,
    Ceiling
    (
      ToFloat(
        (GetYear($${this.parent.paramName_TodayDate}) * 12 + GetMonth($${this.parent.paramName_TodayDate}))
        -
        (GetYear(ExecFirst) * 12 + GetMonth(ExecFirst))
        +
        IIf(GetDay($${this.parent.paramName_TodayDate}) > GetDay(ExecFirst), 1, 0)
      )
      /
      ToFloat(CycleLength)
    ) * CycleLength
  )
,
  2
,
  AddYears
  (
    GetDate(ExecFirst)
  ,
    Ceiling
    (
      ToFloat(
        GetYear($${this.parent.paramName_TodayDate})
        -
        GetYear(ExecFirst)
        +
        IIf(GetDayOfYear($${this.parent.paramName_TodayDate}) > GetDayOfYear(ExecFirst), 1, 0)
      )
      /
      ToFloat(CycleLength)
    ) * CycleLength
  )
)
`;
  }

  private get mtObjWorkTypeScheludedExecutionDateOPath() {
    return this.mtObjWorkTypeEarliestExecutionDateOPath;
  }

  private get mtObjWorkTypeLatestExecutionDateOPath() {
    return `
AddDays
(
  ${this.mtObjWorkTypeEarliestExecutionDateOPath}
  ,
  CaseNull(ExecTime, $${this.parent.paramName_WorkTypeExecTimeInDays})
)
`;
  }

  private get mtObjWorkTypeIsValidEarliestExecutionDateFilterOPath() {
    return `
${this.mtObjWorkTypeEarliestExecutionDateOPath}
<=
Min
(
  AddDays
  (
    GetDate($${this.parent.paramName_TodayDate})
  ,
    CaseNull(LeadTime, $${this.parent.paramName_WorkTypeLeadTimeInDays})
  )
,
  GetDate(CaseNull(ExecLast, MaxDate()))
)
`;
  }

  private get mtObjWorkTypeAllowOnlyValidMtObjWorkTypesFilterOPath() {
    return `
WorkTypeId = $${this.parent.paramName_WorkTypeId}
And
CaseNull(CycleLength, 0) > 0
And
CycleUnit In (0, 1, 2)
And
Not(IsNull(ExecFirst))
And
GetDate(ExecFirst) <= GetDate($${this.parent.paramName_TodayDate})
And
(
  IsNull(ExecLast)
  Or
  GetDate(ExecLast) > GetDate($${this.parent.paramName_TodayDate})
)
`;
  }

  private getMtObjectSubMtObjWorkTypeValue(mtObjWorkTypeSubExpression: string) {
    return `
WorkTypes[WorkTypeId = $${this.parent.paramName_WorkTypeId}].GetValue
(
  ${mtObjWorkTypeSubExpression}
)
`;
  }

  private getMtObjectSubMtObjWorkTypeFilter(mtObjWorkTypeSubFilter: string) {
    return `Exists(WorkTypes[WorkTypeId = $${this.parent.paramName_WorkTypeId} And (${mtObjWorkTypeSubFilter})])`;
  }

  public get mtObjectEarliestExecutionDateOPath() {
    return this.getMtObjectSubMtObjWorkTypeValue(this.mtObjWorkTypeEarliestExecutionDateOPath);
  }

  public get mtObjectScheduledExecutionDateOPath() {
    return this.getMtObjectSubMtObjWorkTypeValue(this.mtObjWorkTypeScheludedExecutionDateOPath);
  }

  public get mtObjectLatestExecutionDateOPath() {
    return this.getMtObjectSubMtObjWorkTypeValue(this.mtObjWorkTypeLatestExecutionDateOPath);
  }

  public get mtObjectIsValidEarliestExecutionDateFilterOPath() {
    return this.getMtObjectSubMtObjWorkTypeFilter(this.mtObjWorkTypeIsValidEarliestExecutionDateFilterOPath);
  }

  public get mtObjectHasNoExistingWorksFilterOPath() {
    return `
Not
(
  Exists
  (
    Works
    [
      WorkTypeId = $${this.parent.paramName_WorkTypeId}
      And
      Not(IsNull(ScheduledExecutionDate))
      And
      IsBetween
      (
        ToFloat
        (
          ScheduledExecutionDate
          -
          ^.${this.mtObjectEarliestExecutionDateOPath}
        )
      ,
        0
      ,
        CaseNull(ExecTime, $${this.parent.paramName_WorkTypeExecTimeInDays})
      )
    ]
  )
)
`;
  }

  public get mtObjectAllowOnlyValidMtObjWorkTypesFilterOPath() {
    return `Exists(WorkTypes[${this.mtObjWorkTypeAllowOnlyValidMtObjWorkTypesFilterOPath}])`;
  }
}

export class ManualModeDataQueryOPathes {
  public readonly paramName_EarliestWorkExecDate = 'EarliestWorkExecDate';
  public readonly paramName_ScheduledWorkExecDate = 'ScheduledWorkExecDate';
  public readonly paramName_LatestWorkExecDate = 'LatestWorkExecDate';
  public readonly paramName_WorkExecTimeInDays = 'WorkExecTimeInDays';

  constructor(private parent: DataQueryOPathes) {}

  public get mtObjectHasNoExistingWorksFilterOPath() {
    return `
Not
(
  Exists
  (
    Works
    [
      WorkTypeId = $${this.parent.paramName_WorkTypeId}
      And
      Not(IsNull(ScheduledExecutionDate))
      And
      IsBetween
      (
        ScheduledExecutionDate
      ,
        GetDate($${this.paramName_EarliestWorkExecDate})
      ,
        GetDate($${this.paramName_LatestWorkExecDate})
      )
    ]
  )
)
`;
  }
}

export class DataQueryOPathes {
  public readonly paramName_TodayDate = 'TodayDate';
  public readonly paramName_WorkTypeId = 'WorkTypeId';
  public readonly paramName_WorkTypeExecTimeInDays = 'WorkTypeExecTimeInDays';
  public readonly paramName_WorkTypeLeadTimeInDays = 'WorkTypeLeadTimeInDays';

  public readonly cyclicMode = new CyclicModeDataQueryOPathes(this);
  public readonly manualMode = new ManualModeDataQueryOPathes(this);
}
